import { cn } from "@/lib/utils";
import { ArrowDown } from "@/components/ui/icons";
import { Button } from "@/components/ui/button";

interface JumpToBottomButtonProps {
  /** Click handler — wired to the parent's `jumpToBottom` callback. */
  onClick: () => void;
  /**
   * When > 0, the pill expands to show a "{n} New" badge and switches
   * to the primary color treatment; when 0, it stays as a small
   * arrow-only button.
   */
  newMessagesCount: number;
}

/**
 * Floating "scroll to bottom" pill anchored to the bottom-right of
 * the message scroll area. Pure render; the parent owns the
 * `showJumpToBottom` boolean that gates whether this is mounted.
 */
export function JumpToBottomButton({
  onClick,
  newMessagesCount,
}: JumpToBottomButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant={newMessagesCount > 0 ? "default" : "outline"}
      size={newMessagesCount > 0 ? "sm" : "icon"}
      className={cn(
        "absolute bottom-4 right-4 z-20 rounded-full shadow-lg",
        newMessagesCount > 0 && "gap-1.5",
      )}
    >
      <ArrowDown size={14} weight="Bold" />
      {newMessagesCount > 0 && (
        <span className="text-xs font-medium">{newMessagesCount} New</span>
      )}
    </Button>
  );
}
